import { api } from './baseApi';
export var restaurantsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            searchUsers: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit, search = _a.search, role = _a.role, isSystem = _a.isSystem;
                    return ({
                        url: "/users/searchWithPagination",
                        params: { page: page, limit: limit, search: search, role: role, isSystem: isSystem },
                    });
                },
            }),
            getUsers: builder.query({
                query: function (params) {
                    return ({
                        url: "/users/allWithPagination",
                        method: 'GET',
                        params: params
                    });
                },
                providesTags: ['Users'],
            }),
            createUser: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/users",
                        body: body,
                    });
                },
                invalidatesTags: ['Users'],
            }),
            editUsers: builder.mutation({
                query: function (_a) {
                    var body = _a.body, id = _a.id;
                    return ({
                        method: 'PATCH',
                        url: "/users/".concat(id),
                        body: body,
                    });
                },
                invalidatesTags: ['Users'],
            }),
            getUsersCreatedInLastDays: builder.query({
                query: function () {
                    return ({
                        url: '/users/countlastdays',
                        method: 'GET',
                    });
                },
                providesTags: ['Users'],
            }),
            deleteUser: builder.mutation({
                query: function (_a) {
                    var userId = _a.userId;
                    return ({
                        method: 'DELETE',
                        url: "/users/".concat(userId),
                    });
                },
                invalidatesTags: ['Users'],
            }),
            uploadPhoto: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: '/file/upload/userphotos',
                        body: body
                    });
                },
                invalidatesTags: ['Users'],
            }),
            getUserById: builder.query({
                query: function (_a) {
                    var id = _a.id, _b = _a.includeCity, includeCity = _b === void 0 ? true : _b;
                    return ({
                        url: "/users/".concat(id),
                        method: 'GET',
                        params: includeCity ? { includeCity: 'true' } : {},
                    });
                },
                providesTags: ['Users'],
            }),
            /** Получить любого пользователя по ID (для просмотра профиля в админке) */
            getOtherUserById: builder.query({
                query: function (id) {
                    return ({
                        url: "/users/byId/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: ['Users'],
            }),
            getAllUsersPaginated: builder.query({
                query: function (params) {
                    return ({
                        url: "/users/all-users-paginated",
                        method: 'GET',
                        params: params,
                    });
                },
                providesTags: ['Users'],
            }),
            // НОВЫЙ ЗАПРОС: Получение ВСЕХ пользователей (для селектов и выпадающих списков)
            // Использует all-users-paginated с большим limit — эндпоинт /users/all-users не существует
            getAllUsers: builder.query({
                query: function (_a) {
                    var search = _a.search;
                    return ({
                        url: "/users/all-users-paginated",
                        method: 'GET',
                        params: { page: 1, limit: 10000, search: search || '' },
                    });
                },
                transformResponse: function (response) { return response.data; },
                providesTags: ['Users'],
            }),
        });
    },
});
export var useGetUserByIdQuery = restaurantsApi.useGetUserByIdQuery, useGetOtherUserByIdQuery = restaurantsApi.useGetOtherUserByIdQuery, useCreateUserMutation = restaurantsApi.useCreateUserMutation, useDeleteUserMutation = restaurantsApi.useDeleteUserMutation, useGetUsersQuery = restaurantsApi.useGetUsersQuery, useEditUsersMutation = restaurantsApi.useEditUsersMutation, useSearchUsersQuery = restaurantsApi.useSearchUsersQuery, useGetUsersCreatedInLastDaysQuery = restaurantsApi.useGetUsersCreatedInLastDaysQuery, useUploadPhotoMutation = restaurantsApi.useUploadPhotoMutation, useGetAllUsersPaginatedQuery = restaurantsApi.useGetAllUsersPaginatedQuery, useGetAllUsersQuery = restaurantsApi.useGetAllUsersQuery;
